import { OpenAPI } from './generatedApi';

export * from './client';
export * from './generatedApi';
export { keycloak, keycloakInit } from './auth/keycloak';
export { KEYCLOAK_MIN_VALIDITY } from './auth/keycloakConfig';

OpenAPI.BASE = __BASE_URL__;
